import React from 'react'
import styles from './page404.module.scss'

const Page404 = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>お探しのページは見つかりませんでした。</h2>
      <h3 className={styles.title}>下記の可能性がございます。</h3>
      <ul className={styles.list}>
        <li>URLが変更された</li>
        <li>ページが存在しない</li>
      </ul>
    </div>
  )
}

export default Page404
